import React, { useState, useEffect } from "react";
import "./service.css";
import { toast } from "react-toastify";
import { getDatabase, ref, onValue, set } from "firebase/database";

function Service() {
  let [Lawyersarr, setLawyersarr] = useState([]);
  let [selectedValue, setselectedValue] = useState({});
  let [loading, setLoading] = useState(false);
  let [select, setSelect] = useState("");
  let [select1, setSelect1] = useState("");

  let ShowCatagorie = (v) => {
    setSelect(v);
    setLoading(false);
    setLoading(true);
    document.getElementById("mainBoxex").style.display = "none";

    const db = getDatabase();
    const starCountRef = ref(db, "/lawyer");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        // console.log(element.val().category);
        arr.push(element.val());
      });

      let array1 = sortArray(arr.filter((e) => e.category.includes(v) == true));
      setLoading(false);
      setLawyersarr(array1);

      // console.log(array1);
      // setLoading(false)
    });
  };
  function sortArray(array) {
    var temp = 0;
    for (var i = 0; i < array.length; i++) {
      for (var j = i; j < array.length; j++) {
        let feed1 =
          (5 * array[j].Star5 +
            4 * array[j].Star4 +
            3 * array[j].Star3 +
            2 * array[j].Star2 +
            1 * array[j].Star1) /
          array[j].TotalRatings;

        let feed2 =
          (5 * array[i].Star5 +
            4 * array[i].Star4 +
            3 * array[i].Star3 +
            2 * array[i].Star2 +
            1 * array[i].Star1) /
          array[i].TotalRatings;

        if (isNaN(feed1)) {
          feed1 = 0;
        }

        if (isNaN(feed2)) {
          feed2 = 0;
        }
        if (feed1 > feed2) {
          temp = array[j];
          array[j] = array[i];
          array[i] = temp;
        }
      }
    }
    return array;
  }

  let SendQuery = (value) => {
    function makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }

    let key = makeid(24);
    console.log(key);
    const db = getDatabase();

    set(ref(db, "requests/" + key), {
      Layer_name: value.first_name + " " + value.last_name,
      laywer_email: value.email,
      client_name: sessionStorage.getItem("LoginName"),
      client_email: sessionStorage.getItem("email"),
      approved: "Not Approved",
      business_Uid: value.uid,
      coustomer_uid: sessionStorage.getItem("uid"),
      uid: key,
      Feedback: "no",
      Star: 0,
      Type_select: select,
      // subType_Select:select1,
      response: "no",
    }).then(() => {
      
      
      
      toast.success("Your Query Send Sucessfully");
      window.location.href = "/services";
      
      
      setTimeout(() => {
        
      }, 2000);

    });
  };

  return (
    <>
      <div className="container">
        <h1 className="service-heading">
          FIND THE RIGHT LAWYER ACCORDING TO YOUR CASE
        </h1>
        <p className="service-para">
          In Lawyers Online you will find Faisalabad's best Lawyers. So don't go
          outside to hire a lawyer. <br /> Only click a button and hire a
          suitable lawyer for your case. Faisalabad's best lawyers are waiting
          for your response.
        </p>
      </div>
      <div className="container">
        <div className="row" id="mainBoxex">
          <div className="col m4 resp" onClick={() => ShowCatagorie("Divorce")}>
            <div className="card darken-1 color card-effect">
              <div className="card-content white-text">
                <span className="card-title">Divorce</span>
                <i className="material-icons mg ">person</i>
                <p className="para">
                  A divorce is a formal ending of a marriage. It's more
                  permanent than a separation and involves a legal process. If
                  you get a divorce, that means the marriage is officially over.
                </p>
                {/* <button className="card-btn1">Check</button> */}
              </div>
            </div>
          </div>
          <div
            className="col m4"
            onClick={() => ShowCatagorie("Child Custody")}
          >
            <div className="card darken-1 color card-effect">
              <div className="card-content white-text">
                <span className="card-title">Child Custody</span>
                <i className="material-icons">person</i>
                <p className="para">
                  Sometimes, a marriage or relationship ends badly. If children
                  are involved, however, the former spouses must still
                  communicate and cooperate to some degree.
                </p>
                {/* <button className="card-btn2">Check</button> */}
              </div>
            </div>
          </div>
          <div className="col m4" onClick={() => ShowCatagorie("Adoption")}>
            <div className="card darken-1 color card-effect">
              <div className="card-content white-text">
                <span className="card-title">Adoption</span>
                <i className="material-icons">person</i>
                <p className="para">
                  Adoptive families are families with a child or children who
                  have been adopted. From that same time, the child's legal
                  connections to its biological parents.
                </p>
                {/* <button className="card-btn3">Check</button> */}
              </div>
            </div>
          </div>
          <div className="col m4 " onClick={() => ShowCatagorie("Conflicts")}>
            <div className="card darken-1 color card-effect shikwa ">
              <div className="card-content white-text">
                <span className="card-title">Conflicts</span>
                <i className="material-icons">person</i>
                <p className="para">
                  Family conflict refers to active opposition between family
                  members. Because of the nature of family relationships, it can
                  take a wide variety of forms.
                </p>
                {/* <button className="card-btn4">Check</button> */}
              </div>
            </div>
          </div>
          <div
            className="col m4 "
            onClick={() => ShowCatagorie("Spousal neglect")}
          >
            <div className="card darken-1 color card-effect">
              <div className="card-content white-text equal ">
                <span className="card-title spn">Spousal Neglect</span>
                <i className="material-icons hello">person</i>
                <p className="para">
                  Making a living is tough. Whether you’re working from home or
                  the typical 9-5, the anxieties of earning a buck can wane in
                  on family activities.
                </p>
                {/* <button className="card-btn5">Check</button> */}
              </div>
            </div>
          </div>
          <div className="col m4 " onClick={() => ShowCatagorie("Dowry")}>
            <div className="card darken-1 color card-effect">
              <div className="card-content white-text">
                <span className="card-title">Infidelity </span>
                <i className="material-icons">person</i>
                <p className="para">
                  Infidelity or unfaithfulness to one’s spouse or mate could
                  cause a division within the family. <br />
                  This outright and blatant disrespect often ignites distrust.
                </p>
                {/* <button className="card-btn6">Check</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mainFlex">
        {loading ? (
          <img src={require("../assets/loading.gif")}></img>
        // ) : Lawyersarr.length == 0 ? (
        //   <span className="para">Currently no Service Available.</span>
        ) : null}

        {Lawyersarr.map((v, i) => {
          if (v.approved !== "no") {
            return (
              <a href="#popup1">
                <div
                  key={i}
                  onClick={() => setselectedValue(v)}
                  class="product-grid"
                >
                  <div class="product-image">
                    <img
                      // class="pic-1"
                      id="images_ALl"
                      style={{ marginLeft: 0 }}
                      src={v.dp}
                    />
                  </div>
                  <div className="title_div">
                    <div class="product-content">
                      <h3 class="title">
                        <a href="">{v.first_name + " " + v.last_name}</a>
                      </h3>
                      <div class="price">Rs. {v.price}</div>
                    </div>
                    <div>
                      <div className="flex">
                        {v.TotalRatings > 0 ? (
                          <>
                            {(5 * v.Star5 +
                              4 * v.Star4 +
                              3 * v.Star3 +
                              2 * v.Star2 +
                              1 * v.Star1) /
                              v.TotalRatings}
                            <img
                              style={{
                                width: 15,
                                height: 15,
                                margin: 0,
                                padding: 0,
                                marginTop: -5,
                              }}
                              src="https://www.freepnglogos.com/uploads/star-png/star-vector-png-transparent-image-pngpix-21.png"
                            ></img>
                          </>
                        ) : null}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            );
          }
        })}
        <div id="popup1" class="overlay">
          <div class="popup">
            <img
              // class="pic-1"
              id="images_ALl"
              style={{ marginLeft: 0 }}
              src={selectedValue.dp}
            />
            <a class="close" href="#">
              &times;
            </a>
            <div class="content">
              <h4>
                {selectedValue.first_name + " " + selectedValue.last_name}
              </h4>

              <h5>{selectedValue.email}</h5>

              <h5>Min Price : {selectedValue.price}pkr</h5>

              <button
                onClick={() => SendQuery(selectedValue)}
                className="btn btn-danger"
              >
                Hire ME
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Service;
